import { render, staticRenderFns } from "./commissieDetails.vue?vue&type=template&id=5ce255f4"
import script from "./commissieDetails.vue?vue&type=script&lang=js"
export * from "./commissieDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports